export const IMAGE_PAGER_HEIGHT = 36;
export const IMAGE_PAGER_WIDTH = 130;
export const IMAGE_PAGER_BUTTON_WIDTH = 34;
export const IMAGE_PAGER_RADIUS_CSS = "8px";
export const IMAGE_PAGER_ICON_SIZE = 11;
export const IMAGE_PAGER_FONT_SIZE = 13;
export const IMAGE_ALBUM_BUTTON_SIZE = 36;
export const IMAGE_ALBUM_ICON_SIZE = 18;
export const SELFIE_PILL_HEIGHT = 22;
export const SELFIE_PILL_PADDING = 9;
export const SELFIE_PILL_FONT_SIZE = 10;
export const SELFIE_PILL_RADIUS_CSS = "11px";
export const SELFIE_PILL_LETTER_SPACING = 0.4;
